import _regeneratorRuntime from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _classCallCheck from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
import _asyncToGenerator from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
export function assign(target, source) {
  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      target[key] = source[key];
    }
  }
}
export function chunk(iterable, length) {
  var results = [];
  var lengthOfIterable = iterable.length;

  for (var i = 0; i < lengthOfIterable; i += length) {
    var chunked = [];

    for (var ci = i; ci < i + length; ci++) {
      chunked.push(iterable[ci]);
    }

    results.push(chunked);
  }

  return results;
}
export function endsWith(string, expectedEnding) {
  if (string.length < expectedEnding.length) {
    return false;
  }

  var actualEnding = string.substr(string.length - expectedEnding.length);
  return actualEnding === expectedEnding;
}
export function forEach(iterable, func) {
  var length = iterable.length;

  for (var i = 0; i < length; i++) {
    func(iterable[i], i);
  }
}
export function invert(oldObj) {
  var newObj = {};

  for (var key in oldObj) {
    if (oldObj.hasOwnProperty(key)) {
      var value = oldObj[key];
      newObj[value] = key;
    }
  }

  return newObj;
}
export function range(n) {
  var results = [];

  for (var i = 0; i < n; i++) {
    results.push(i);
  }

  return results;
}
export function times(numTimes, func) {
  var results = [];

  for (var i = 0; i < numTimes; i++) {
    results.push(func(i));
  }

  return results;
}
export function toArray(iterable) {
  var results = [];
  var length = iterable.length;

  for (var i = 0; i < length; i++) {
    results.push(iterable[i]);
  }

  return results;
}
export function toArrayRecursively(input) {
  if (input.length) {
    return toArray(input).map(toArrayRecursively);
  }

  return input;
} // copied from https://github.com/academia-de-codigo/parse-content-range-header/blob/master/index.js

export function parseContentRange(headerValue) {
  if (!headerValue) {
    return null;
  }

  if (typeof headerValue !== 'string') {
    throw new Error('invalid argument');
  }

  var parseInt = function parseInt(number) {
    return Number.parseInt(number, 10);
  }; // Check for presence of unit


  var matches = headerValue.match(/^(\w*) /);
  var unit = matches && matches[1]; // check for start-end/size header format

  matches = headerValue.match(/(\d+)-(\d+)\/(\d+|\*)/);

  if (matches) {
    return {
      unit: unit,
      first: parseInt(matches[1]),
      last: parseInt(matches[2]),
      length: matches[3] === '*' ? null : parseInt(matches[3])
    };
  } // check for size header format


  matches = headerValue.match(/(\d+|\*)/);

  if (matches) {
    return {
      unit: unit,
      first: null,
      last: null,
      length: matches[1] === '*' ? null : parseInt(matches[1])
    };
  }

  return null;
}
/*
 * Promisified wrapper around 'setTimeout' to allow 'await'
 */

export function wait(_x) {
  return _wait.apply(this, arguments);
}

function _wait() {
  _wait = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(milliseconds) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              return setTimeout(resolve, milliseconds);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _wait.apply(this, arguments);
}

export function zip(a, b) {
  var A = Array.isArray(a) ? a : Array.from(a);
  var B = Array.isArray(b) ? b : Array.from(b);
  return A.map(function (k, i) {
    return [k, B[i]];
  });
} // Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error

export var AbortError =
/*#__PURE__*/
function (_Error) {
  _inherits(AbortError, _Error);

  function AbortError(params) {
    var _this;

    _classCallCheck(this, AbortError);

    // Pass remaining arguments (including vendor specific ones) to parent constructor
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbortError).call(this, params)); // Maintains proper stack trace for where our error was thrown (only available on V8)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this)), AbortError);
    }

    _this.name = 'AbortError';
    return _this;
  }

  return AbortError;
}(_wrapNativeSuper(Error));
export var CustomAggregateError =
/*#__PURE__*/
function (_Error2) {
  _inherits(CustomAggregateError, _Error2);

  function CustomAggregateError(errors, message) {
    var _this2;

    _classCallCheck(this, CustomAggregateError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(CustomAggregateError).call(this, message));
    _this2.errors = errors;
    _this2.message = message;
    _this2.name = 'AggregateError';
    return _this2;
  }

  return CustomAggregateError;
}(_wrapNativeSuper(Error));
export var AggregateError = CustomAggregateError;